import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { FormActionsComponent } from '../form-actions.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../service/translation-service.service';

@Component({
  selector: 'app-waiting',
  templateUrl: 'waiting.component.html',
  styleUrls: ['login-reset-register.component.scss'],
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    FormActionsComponent,
    MatDividerModule,
    MatSnackBarModule,
    TranslateModule,
  ],
})
export class WaitingComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly translation = inject(TranslationService);
  adminAvailable!: boolean;

  ngOnInit(): void {
    this.route.data.subscribe(({ adminAvailable }) => (this.adminAvailable = adminAvailable));
  }

  schedulaCall() {
    window.location.href = this.translation.productDemoUrl();
  }

  startTeamsCall() {
    window.open('https://teams.live.com/l/invite/FEAd9P32sLTYjY7LgI', '_blank');
  }
}
